// Links rendered from user/catalog data (datasheet_url, store links, websites…) are bound
// with :href, which Vue does not sanitize. A javascript:/data:/vbscript: target would run
// on the app origin when clicked — block activation globally (audit 2026-10-11, f44).
const UNSAFE_SCHEME = /^\s*(javascript|data|vbscript):/i

export default defineNuxtPlugin(() => {
  const guard = (event: Event) => {
    const target = event.target as Element | null
    const anchor = target?.closest?.('a[href]') as HTMLAnchorElement | null
    if (anchor && UNSAFE_SCHEME.test(anchor.getAttribute('href') || '')) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
  document.addEventListener('click', guard, true)
  document.addEventListener('auxclick', guard, true)
})
